module.exports = __webpack_public_path__ + "static/media/puerto-rico.35e519ff.svg";